import React, { Component } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";
import InvestorsData from '../custom-components/iform/investors-data';
import OtherInfo from '../custom-components/iform/other-info';
import NextOfKin from '../custom-components/iform/next-of-kin';
import IDMeans from '../custom-components/iform/id-means';
import BankDetails from '../custom-components/iform/bank-details';
import Confirmation from '../custom-components/iform/confirmation';
import { Header } from '../custom-components/header';
import loadScripts from '../../dassets/js/custom';

export default class CreateIForms extends Component {
  componentDidMount() {
    loadScripts();
  }
    constructor(props) {
        super(props);

        // this.onChangeFiles = this.onChangeFiles.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.sendIForm = this.sendIForm.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);

        this.state = {
            step: 1
        }

        this.fieldValues = {
            type: "individual-kyc",
            title: null,
            gender: null,
            surname: null,
            first_name: null,
            other_name: null,
            email: null,
            dob: null,
            marital_status: null,
            mother_maiden_name: null,
            id_no: null,
            phone1: null,
            phone2: null,
            residential_add: null,
            contact_add: null,
            country: null,
            nationality: null,
            state_of_origin: null,
            city_lga: null,
            nok_surname: null,
            nok_first_name: null,
            nok_other_name: null,
            nok_relationship: null,
            nok_contact_add: null,
            nok_phone: null,
            nok_email: null,
            id_type: null,
            number: null,
            issue_date: null,
            expiry_date: null,
            etcc: null,
            bank_name: null,
            acct_name: null,
            acct_no: null,
            acct_type: null,
            opening_date: null,
            bvn: null,
            prefered_account: null,
            heard_about_us: [],
            kyc_docs: [{ label: "Utility Bill", value: "Utility Bill"}],
            receive_reports: [],
        }
    }

    saveValues(fields) {
        this.fieldValues = Object.assign({}, this.fieldValues, fields);
    }

    nextStep() {
        this.setState({
            step: this.state.step + 1
        })
    }

    // Same as nextStep, but decrementing
    previousStep() {
        this.setState({
            step: this.state.step - 1
        })
    }

    async onSubmit() {
        let i = 0;
        this.fieldValues.kyc_docs.find(o => {
            if (o.name === 'Utility Bill') {
                i++;
            }
        });

        if(this.fieldValues.kyc_docs.some(r=> ["Driver's Licence","International Passport","National ID Card","Permanent Voters Card"].includes(r.name))){
            i++;
        }

        if (i < 2) {
            toast.error("You need to upload an ID card and Utility Bill");
            return
        }
        
        this.fieldValues.kyc_docs = JSON.stringify(this.fieldValues.kyc_docs);
        this.fieldValues.heard_about_us = this.fieldValues.heard_about_us.toString();
        this.fieldValues.receive_reports = this.fieldValues.receive_reports.toString();

        this.fieldValues.signature_path = `iform_signature_${this.fieldValues.surname}_${this.fieldValues.first_name}_${new Date().getTime()}.png`;
        this.fieldValues.passport_path = `iform_passport_${this.fieldValues.surname}_${this.fieldValues.first_name}_${new Date().getTime()}.png`;
        const formData = new FormData();
        formData.append('file_no', this.fieldValues.documents.length + 2);
        formData.append(`file0`, this.fieldValues.passport, this.fieldValues.passport_path);
        formData.append(`file1`, this.fieldValues.signature, this.fieldValues.signature_path);
        this.fieldValues.documents.forEach((doc, i) => {
            formData.append(`file${i + 2}`, doc.file, doc.path);
        });
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        await api.post(`/kycforms/individual/upload`, formData, config,)
            .then(res => {
                console.log("Image uploaded successfully");
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });

        this.sendIForm();
    }

    sendIForm() {

        api.post(`/kycforms/individual`, this.fieldValues)
            .then(res => {
                toast.success("Thanks for taking time to submit your details, we will contact you via email.");
                this.props.history.push(`/`)
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });
    }

    render() {
        switch (this.state.step) {
            case 1:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><InvestorsData fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    saveValues={this.saveValues} /></section>
            case 2:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><OtherInfo fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 3:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><NextOfKin fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 4:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><IDMeans fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 5:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><BankDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 6:
                return <section><Header name="Individual KYC Update Form" step={this.state.step} max="6"/><Confirmation fieldValues={this.fieldValues}
                    submit={this.onSubmit}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            default:

        }
    }
}